var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstallmentsinline = function SvgInstallmentsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "40 40 100 110"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeWidth: 4.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.6 136.5H50.05V59.304h15.48M118.743 59.304h16.003V136.5M76.436 59.304h31.483M50.87 81.148h84.696M71.226 50.05v18.04M113.571 50.05v18.04"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#21201F",
    stroke: "#21201F",
    strokeWidth: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.143 114.533-.456.05.058.456a8.983 8.983 0 0 0 9.08 7.848c2.93-.001 5.385-.755 7.123-2.136 1.748-1.39 2.736-3.388 2.755-5.786v-.004c0-3.813-3.366-6.473-8.576-7.309-2.925-.469-4.599-1.169-5.54-2.005-.912-.808-1.19-1.791-1.19-3.006 0-1.802.901-2.927 2.07-3.624 1.19-.71 2.65-.962 3.655-.962 1.799 0 3.204.411 4.272 1.205 1.067.793 1.845 2.003 2.322 3.69l.123.433.434-.122 1.318-.37.435-.123-.123-.435c-.604-2.139-1.645-3.79-3.136-4.9-1.49-1.112-3.386-1.654-5.645-1.654-1.962 0-3.95.574-5.458 1.72-1.52 1.154-2.543 2.886-2.543 5.142 0 2.032.651 3.64 2.106 4.847 1.427 1.184 3.583 1.943 6.51 2.414l.003.001c.804.124 2.504.473 3.99 1.271 1.489.799 2.662 1.987 2.662 3.773 0 1.748-.704 3.143-1.974 4.112-1.283.98-3.178 1.552-5.584 1.552l-.01.001a6.72 6.72 0 0 1-6.811-5.84l-.058-.438-.439.048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.972 91v-.451h-2.276v13.641000000000002h2.2760000000000002V91ZM93.972 113.856v-.451h-2.276v14.446000000000002h2.2760000000000002v-13.995000000000001Z"
  }))));
};
export default SvgInstallmentsinline;